import classNames from "classnames";

interface CheckboxProps {
  id?: string;
  label?: string;
  checked?: boolean;
  onChange?: (arg: any, id?: string) => void;
  className?: string;
  disabled?: boolean;
  name?: string;
  child?: React.ReactNode;
  labelClassName?: string;
  required?: boolean;
}

const Checkbox = (props: CheckboxProps) => {
  const {
    id,
    label,
    checked,
    onChange,
    className = "",
    disabled,
    name,
    child,
    labelClassName = "",
    required = false,
  } = props;
  return (
    <div
      className={classNames("relative flex items-center", {
        "opacity-50": disabled,
        [className]: !!className,
      })}
    >
      <div className="flex items-center">
        <input
          id={id}
          aria-describedby={id}
          name={name ?? id}
          type="checkbox"
          className={classNames(
            "rounded dark:border-gray-400 cursor-pointer text-teal-400 bg-transparent",
            {
              "!cursor-not-allowed": disabled,
            }
          )}
          checked={checked}
          onChange={(e) => {
            onChange?.(e.target.checked, id);
          }}
          disabled={disabled}
          required={required}
        />
      </div>
      {!!label && (
        <label
          htmlFor={id}
          className={classNames(
            "ml-3 text-gray-700 dark:text-gray-200 cursor-pointer text-base text-left w-full break-words",
            {
              "!cursor-not-allowed": disabled,
              [labelClassName]: !!labelClassName,
            }
          )}
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
